import React from "react";
import { Pane, Button, Text, Tooltip, Spinner, ShoppingCartIcon, } from "evergreen-ui";
import { MaterialIcon } from "./MaterialIcon";
import { Icons } from "../Misc";
import { Link } from "react-router-dom";
export * from "./BookOrder";
export * from "./CartProvider";
import { useCart } from "./CartProvider";
import "./cart.scss";
import { CartSubtotal } from "./SubTotal";
let CartItem = (props) => {
    var _a, _b;
    let Cart = useCart();
    // console.log(Cart.cartItems.color)
    return (React.createElement(Pane, { display: "flex", flexDirection: "row", marginBottom: "10px", width: "100%", height: "85px" },
        React.createElement(MaterialIcon, { material: props.item.selMaterial ? props.item.selMaterial.Mgroup : null, order: props.item, onClick: () => {
                props.onSelectOrder && props.onSelectOrder(props.item.key);
            } }),
        React.createElement(Button, { height: "100%", width: "100%", marginBottom: "16", flex: "1", borderRadius: "0px", onClick: () => {
                console.log(props.item.key);
                props.onSelectOrder(props.item.key);
            } },
            React.createElement(Pane, { display: "flex", flexDirection: "column", textAlign: "center", width: "100%" },
                React.createElement(Tooltip, { content: (_a = props.item.book) === null || _a === void 0 ? void 0 : _a.display },
                    React.createElement(Text, { fontSize: 15, marginBottom: "10px", overflow: "hidden" },
                        props.item.qty,
                        " x ", (_b = props.item.book) === null || _b === void 0 ? void 0 :
                        _b.display)),
                React.createElement(Pane, { display: "flex", flexDirection: "row", textAlign: "center", justifyContent: "center", marginBottom: 8, alignItems: "center", gap: "10%", flexWrap: "wrap" },
                    props.item.bends[0] != null && (React.createElement(Tooltip, { content: "Folding" },
                        React.createElement(Pane, null, Icons.folding[0]))),
                    props.item.color && (React.createElement(Tooltip, { content: props.item.color },
                        React.createElement(Pane, null, Icons.painting[0])))))),
        React.createElement(Button, { className: "Cart_Close_BTN", flex: "0.2", onClick: () => {
                Cart.remove(props.item.key);
            }, height: "100%", style: { borderRadius: "0px 10px 10px 0px" } }, "\u274C")));
};
let Total = (props) => {
    // console.log("In Total: ", props)
    let OnRequestCount = props.cartItems.filter((item) => {
        return item.selMaterial && item.selMaterial.Available == "On Request";
    }).length;
    let tbq = false;
    props.cartItems &&
        props.cartItems.map((item) => {
            if (item.assembly || item.welding || item.color) {
                tbq = true;
            }
        });
    let addPartLines = OnRequestCount > 0 || tbq
        ? "To be quoted"
        : (props.cartItems &&
            props.cartItems.reduce((p, c) => {
                return p + parseFloat(c.selMaterial ? c.selMaterial.qtycost : 0);
            }, 0)).toString();
    let setupFees = (props.cartItems ? props.cartItems.reduce((p, c) => p + c.SetupFee, 0) : 0).toString();
    return React.createElement(CartSubtotal, { setupFees: setupFees, jobTotal: addPartLines });
};
export function Cart(props) {
    let Cart = useCart();
    if (Cart.loading)
        return (React.createElement(Pane, { clearfix: true, className: "SideCart", alignItems: "center", display: "flex", width: 350, flexDirection: "column", background: "blueTint", padding: 8, overflow: "none" },
            " ",
            React.createElement(Pane, { display: "flex", background: "white", alignItems: "center", justifyContent: "center", flexDirection: "column", width: "100%", height: "100%" },
                React.createElement(Spinner, null),
                React.createElement("br", null),
                React.createElement(Text, null,
                    React.createElement("strong", null, "Loading Cart"),
                    " ",
                    Cart.loading))));
    return (Cart.count > 0 && (React.createElement(Pane, { clearfix: true, className: "SideCart", alignItems: "center", display: "flex", width: 350, flexDirection: "column", background: "blueTint", padding: 8, overflow: "none" },
        React.createElement(Pane, { display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: "10px" },
            React.createElement(ShoppingCartIcon, { size: 25 }),
            React.createElement(Text, { size: 600 },
                React.createElement("h2", null,
                    "Cart",
                    " ",
                    Cart.cartItems &&
                        Cart.cartItems.length > 0 &&
                        `(${Cart.cartItems.length})`))),
        React.createElement(Pane, { overflowY: "scroll", alignItems: "center", display: "flex", width: 350, flexDirection: "column", background: "blueTint", padding: 8, overflow: "auto" }, Cart.cartItems &&
            Cart.cartItems.map((item, i) => (React.createElement(CartItem, Object.assign({ onSelectOrder: (key) => console.log(key), key: item.key }, props, { 
                // onRemove={() => {
                //   Cart.remove(item.key);
                // }}
                item: item }))))),
        React.createElement(Total, { cartItems: Cart.cartItems }),
        React.createElement(Link, { to: "/cart", style: { color: "inherit", textDecoration: "inherit", width: "100%" } },
            React.createElement(Button, { marginTop: "5", appearance: "primary", height: "40px", width: "100%", padding: "10" },
                React.createElement(Text, { color: "white", size: 600 },
                    React.createElement("strong", null, "Review Order")))))));
}
